import apiClient from '@/services/axios'

export async function get(venueId, caseWorkerId) {
  var params = { 'venue-details-id': venueId, 'case-worker-id': caseWorkerId }

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/requests', { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get requests.')
}
